import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Button } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import TrustBar from "../components/TrustBar";
import WhyUs from "../components/WhyUs";
import HowItWorks from "../components/HowItWorks";
import ProductSection from "../components/ProductSection";
import TestimonialsStrip from "../components/TestimonialsStrip";
import FAQ from "../components/FAQ";
import { PRODUCT_CATEGORIES, getProductsByCategory } from "../data/products";
import "./HomePage.css";

const SECTION_HASHES = ["#hn-plans", "#hn-plans-cloud", "#hn-plans-devop", "#hn-plans-remote"];

const HomePage = () => {
  const location = useLocation();
  const dedicated = getProductsByCategory(PRODUCT_CATEGORIES.DEDICATED);
  const cloud = getProductsByCategory(PRODUCT_CATEGORIES.CLOUD);
  const devop = getProductsByCategory(PRODUCT_CATEGORIES.DEVOP);
  const remoteDesktop = getProductsByCategory(PRODUCT_CATEGORIES.REMOTE_DESKTOP);

  const scrollToPlans = () => {
    const el = document.getElementById("hn-plans");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const hash = location.hash;
    if (hash && SECTION_HASHES.includes(hash)) {
      const id = hash.slice(1);
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 150);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <>
      <Navbar />
      <main className="hn-main">
        <section className="hn-hero">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg="10">
                <h1 className="hn-hero-title">Hosting that&apos;s full of flavor</h1>
                <p className="hn-hero-tagline">
                  Powerful hosting, served fresh. Dedicated instances, cloud processing, and DevOp deployment—all with 97% uptime and dedicated support.
                </p>
                <Button color="warning" size="lg" className="hn-hero-cta mt-3" onClick={scrollToPlans}>
                  View plans
                </Button>
              </Col>
            </Row>
          </Container>
        </section>

        <TrustBar />
        <WhyUs />
        <HowItWorks />

        <ProductSection category="dedicated" products={dedicated} />
        <ProductSection category="cloud" products={cloud} />
        <ProductSection category="devop" products={devop} />
        <ProductSection category="remote" products={remoteDesktop} />

        <TestimonialsStrip />
        <FAQ />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
